webpackJsonp([186063380969677],{

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.postQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(57);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Container = __webpack_require__(65);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Grid = __webpack_require__(34);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Typography = __webpack_require__(35);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _styles = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {};
	};
	
	var FeaturesPage = function FeaturesPage(_ref) {
	  var classes = _ref.classes,
	      data = _ref.data;
	  return _react2.default.createElement(
	    _Grid2.default,
	    { container: true },
	    _react2.default.createElement(
	      _Grid2.default,
	      { item: true, xs: 12 },
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          _Grid2.default,
	          { item: true, xs: 12 },
	          _react2.default.createElement(
	            _Typography2.default,
	            { variant: 'display2', align: 'center' },
	            'Blog Posts'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('hr', null),
	          _react2.default.createElement(
	            'ul',
	            null,
	            data.allMarkdownRemark.edges.map(function (_ref2) {
	              var node = _ref2.node;
	              return _react2.default.createElement(
	                'li',
	                { key: node.id },
	                _react2.default.createElement(
	                  _Typography2.default,
	                  { variant: 'body2' },
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: node.frontmatter.path },
	                    node.frontmatter.title
	                  )
	                )
	              );
	            })
	          ),
	          _react2.default.createElement('hr', null),
	          _react2.default.createElement(
	            _Typography2.default,
	            { variant: 'body1' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/' },
	              'Go back to the homepage'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _styles.withStyles)(styles)(FeaturesPage);
	var postQuery = exports.postQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-jsx-32ac1cf05dd491ed08f9.js